import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getDecks } from '../features/decks/decksSlice'
import Spinner from '../components/Spinner'
import { sendPageView } from '../gtmUtils'

function Deck() {
	const dispatch = useDispatch()

	const { decks, isLoading, isSuccess } = useSelector((state) => state.decks)

	useEffect(() => {
		sendPageView()
		dispatch(getDecks())
	}, [dispatch])

	return (
		<>
			{isLoading || !isSuccess ? (
				<Spinner />
			) : (
				<div className='container'>
					<div className='deck'>
						<h1 className='large'>Decks</h1>
						<p className='lead'>Specializing in deck resurfacing and railing installations.</p>
						<p className='lead'>
							We will replace the surface of your rotted deck and revitialize the space. We will
							also level and replace the joists as necessary.
						</p>
						<p className='lead'>
							Railings can give your deck a distincting look, we specialize in the installation of
							aluminum and glass railing.
						</p>
						<br />

						<p className='large'>Previous Projects</p>
						<div className='projects-grid'>
							<div className='project'>
								<h3>Deck Resurfacing and Leveling</h3>
								<p>Before</p>

								<div className='project-grid'>
									{decks[0].before.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>

								<p>
									During: The supports had sagged sitting on the concrete blocks. The blocks were
									removed, and new supports installed fastened directly to the concrete platorm.
								</p>
								<div className='project-grid'>
									{decks[0].during.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>

								<p>Finished with the railing reinstalled</p>
								<div className='project-grid'>
									{decks[0].after.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>
							</div>
						</div>

						<div className='projects-grid'>
							<div className='project'>
								<h3>Deck Resurfacing and Leveling</h3>
								<p>
									Signifant leveling was done as some of the support posts had heaved in the ground.
								</p>
								<p>
									Support beams around the concrete patio had to be replaced as they were rotten.
								</p>

								<div className='project-grid'>
									{decks[1].after.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>
							</div>

							<div className='projects-grid'>
								<div className='project'>
									<h3>Deck Rebuild</h3>
									<p>Supporting joists and deck boards were all rotten and had to be replaced.</p>
									<p>Before</p>
									<div className='project-grid'>
										{decks[2].before.map((image, index) => (
											<div className='project-item' key={index}>
												<a href={image.full} target='_blank' rel='noreferrer'>
													<img src={image.thumbnail} alt={image.name} />
												</a>
											</div>
										))}
									</div>

									<p>During</p>
									<div className='project-grid'>
										{decks[2].during.map((image, index) => (
											<div className='project-item' key={index}>
												<a href={image.full} target='_blank' rel='noreferrer'>
													<img src={image.thumbnail} alt={image.name} />
												</a>
											</div>
										))}
									</div>

									<p>Finished</p>
									<div className='project-grid'>
										{decks[2].after.map((image, index) => (
											<div className='project-item' key={index}>
												<a href={image.full} target='_blank' rel='noreferrer'>
													<img src={image.thumbnail} alt={image.name} />
												</a>
											</div>
										))}
									</div>
									<p className='bg-primary'>Testimonial</p>
									<p>
										We are very pleased with the new deck Paul built for us this summer replacing
										our old cedar deck. A ground up build with an attractive new design. From the
										initial meeting, the design stage, and through to completion, we were impressed
										with the knowledgeable, helpful information and suggestions provided. Paul
										delivered quality, professional workmanship throughout the project.{' '}
									</p>
									<p>
										<strong>
											We definitely recommend Sproxton General Contracting. Five Stars!
										</strong>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default Deck
